var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceRemindersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Safety/SafetyAlert/32",
    stroke: "#00095B",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2266153,15.9261736 C29.2266153,17.9136484 27.6064717,19.9011231 24.7712205,19.9011231 C22.3410051,19.9011231 20.3158256,17.9136484 20.3158256,15.9261736 L20.3158256,4.39881994 C15.050359,6.38629471 11,10.3612442 11,15.9261736 C11,21.093608 15.050359,25.4660525 20.3158256,27.0560323 L20.3158256,64.023063 C20.3158256,66.0105378 22.3410051,67.9980125 24.7712205,67.9980125 C27.6064717,67.9980125 29.2266153,66.0105378 29.2266153,64.023063 L29.2266153,27.0560323 C34.0870461,25.4660525 38.137405,21.093608 38.137405,15.9261736 C38.137405,10.3612442 34.0870461,6.38629471 29.2266153,4.39881994 L29.2266153,15.9261736 Z M56.3640203,36.1970912 L56.3640203,15.9281611 L60.8194152,15.9281611 L56.3640203,4 L51.9086255,4 L47.0481947,15.9281611 L51.9086255,15.9281611 L51.9086255,36.1970912 L47.0481947,39.7745458 L47.0481947,62.0375757 C47.0481947,65.6150303 49.883446,68 53.933805,68 C57.1740921,68 60.8194152,65.6150303 60.8194152,62.0375757 L60.8194152,39.7745458 L56.3640203,36.1970912 Z",
    id: "VehicleMaintenance"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceRemindersIcon);
export default __webpack_public_path__ + "static/media/service-reminders-icon.35a52b4c32edfa09fb25991be76e4f8b.svg";
export { ForwardRef as ReactComponent };